import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

/**
 * web_walking_male_bulk_change — лендинг-эксперимент (вариант B).
 * База: walking-m (loader-walking-m + age-walking-m). Меняем только тайтлы:
 *  - экран 0 (loader): «Indoor Walking Plan / Based on Your Age»
 *  - экран 1 (age): «INDOOR WALKING PLAN» (компонент аплеркейсит) — сетка и сабтайтл из базы
 * Figma: 21070-25248.
 */
const extensionSchema: Partial<LandingScreenSchema>[] = [
	{
		components: {
			LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
				title: 'Indoor Walking Plan<br>Based on Your Age',
				size: 'small',
				customStyles: {
					marginLeft: '3rem',
					marginRight: '3rem',
				},
			}),
		},
	},
	{
		components: {
			LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
				title: 'Indoor Walking Plan',
				size: 'large',
				uppercase: true,
			}),
		},
	},
]

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => mergeDeep([...schemas], extensionSchema)
